import React from 'react';
import { GitCompare, Check } from 'lucide-react';
import { useCompareTray } from '../../context/CompareTrayContext';

/**
 * CompareToggle - drop onto any catalogue card to add/remove it from the
 * global compare tray. Pass a minimal snapshot (`item`), the compare
 * `kind`, and a stable `id`.
 */
const CompareToggle = ({ item, kind, id, className = '', label = 'Compare', stopPropagation = true }) => {
  const { isInTray, toggle } = useCompareTray();
  const active = isInTray(id, kind);
  return (
    <button
      type="button"
      onClick={(e) => {
        if (stopPropagation) { e.preventDefault(); e.stopPropagation(); }
        toggle(item, kind, id);
      }}
      aria-pressed={active}
      data-testid={`compare-toggle-${id}`}
      className={`inline-flex items-center gap-1.5 text-[12px] font-semibold px-2.5 py-1 rounded-full border transition-colors ${
        active
          ? 'bg-[#1d1d1f] text-white border-[#1d1d1f]'
          : 'bg-white/95 text-[#1d1d1f] border-gray-200 hover:border-[#1d1d1f]'
      } ${className}`}
    >
      {active ? <Check className="w-3.5 h-3.5" /> : <GitCompare className="w-3.5 h-3.5" />}
      {active ? 'Added' : label}
    </button>
  );
};

export default CompareToggle;
